export default {
    set_claim_public: (state, payload) => { 
        state.claim_public = payload 
    },
    set_claim_public_filters: (state, payload) => { 
        state.claim_public_filters = payload
    }
}